import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import useWindowSize from '../hooks/useWindowSize';

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.75a4.85 4.85 0 01-1.01-.06z"/>
  </svg>
);

function Footer() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const redes = [
    { icon: <FacebookIcon />, label: 'Facebook', url: 'https://www.facebook.com/GaliTicket' },
    { icon: <InstagramIcon />, label: 'Instagram', url: 'https://www.instagram.com/gali_ticket' },
    { icon: <TikTokIcon />, label: 'TikTok', url: 'https://www.tiktok.com/@galiticket' },
  ];

  return (
    <footer style={{ backgroundColor: colors.bgSecondary, borderTop: '1px solid ' + colors.border, marginTop: '3rem' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: isMobile ? '1.5rem 1rem' : '1.5rem 2rem', display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
          <img src="/logo.png" alt="GaliTicket" style={{ height: '28px', width: 'auto', objectFit: 'contain' }} />
          <span style={{ color: colors.textSecondary, fontSize: '0.82rem' }}>{'© ' + new Date().getFullYear() + ' GaliTicket'}</span>
        </div>

        <div style={{ display: 'flex', gap: isMobile ? '1rem' : '1.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
          <span onClick={() => navigate('/vende-tus-entradas')} style={{ color: colors.textSecondary, fontSize: '0.82rem', cursor: 'pointer' }}>Vende con nosotros</span>
          <span onClick={() => navigate('/contact')} style={{ color: colors.textSecondary, fontSize: '0.82rem', cursor: 'pointer' }}>Contacto</span>
          <span onClick={() => navigate('/privacy')} style={{ color: colors.textSecondary, fontSize: '0.82rem', cursor: 'pointer' }}>Privacidad</span>
        </div>

        <div style={{ display: 'flex', gap: '0.8rem', alignItems: 'center' }}>
          {redes.map(function(red) {
            return (
              
              <a
                key={red.label}
                href={red.url}
                target="_blank"
                rel="noopener noreferrer"
                title={red.label}
                style={{ color: colors.textSecondary, display: 'flex', alignItems: 'center' }}
              >
                {red.icon}
              </a>
            );
          })}
        </div>

      </div>
    </footer>
  );
}

export default Footer;